// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class InlineObject1 {
    static getAttributeTypeMap() {
        return InlineObject1.attributeTypeMap;
    }
}
InlineObject1.discriminator = undefined;
InlineObject1.additionalProperties = false;
InlineObject1.attributeTypeMap = [
    {
        "name": "type",
        "baseName": "type",
        "type": "number"
    },
    {
        "name": "attachment",
        "baseName": "attachment",
        "type": "RequestFile"
    },
    {
        "name": "externalPartyCode",
        "baseName": "externalPartyCode",
        "type": "string"
    },
    {
        "name": "externalProgramCode",
        "baseName": "externalProgramCode",
        "type": "string"
    },
];
//# sourceMappingURL=inlineObject1.js.map